// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"index-module--header-container--3FRdO","bigLink":"index-module--big-link--1N7Ol"};